import React, { PropTypes } from 'react';
import classNames from 'classnames';
// import { Link } from 'react-router';


const LangSwitch = ({ lang, toggle, uris }) => (
  <div className={classNames('langswitch')} onClick={() => toggle(uris, lang)}>
    <div className={classNames({ active: (lang === 'en') })}>EN</div>
    <div className={classNames({ active: (lang === 'fr') })}>FR</div>
  </div>
);

LangSwitch.propTypes = {
  lang: PropTypes.string.isRequired,
  uris: PropTypes.object.isRequired,
  toggle: PropTypes.func.isRequired,
};

export default LangSwitch;



// WEBPACK FOOTER //
// ./common/components/LangSwitch.js